import AtmosphereTemplate from '../../../class/service/bt/AtmosphereTemplate'
import App from '../../../class/App.js'
import SingleOfferTemplatLoader from "../../../class/templateLoader/SingleOfferTemplatLoader"
import {
    VideoBridgeInit,
} from "../../../api";


window.MTG_LAUNCH_Atmosphere = function (cb) {
    App.onJSBridgeConnected(()=>{init()})
    //init()
    function init(){
        App.loadTemplate({
            templateClass: AtmosphereTemplate,
            templateLoader: SingleOfferTemplatLoader,
            loadCallback: cb,
            fetchFun:VideoBridgeInit
        }).then(({data, tpl})=>{
            //App.readyToShowAD()
            console.log('before entry tpl.whenLoad ============>')
            tpl.whenLoad().then(() => {
                console.log('entry tpl.whenLoad ============>')
                App.readyToShowAD()
                // isReady
                // 调用自动load方法
                tpl.platform.callLoadAds({
                    ...App.initData,
                    campaign: tpl.campaign,
                    nodeName: "isReady",
                })
            }).catch(() => {
                // 广告渲染失败，通知sdk load失败
                console.log('entry tpl.whenLoad err============>')
                App.failureToShowAD()
            })
        }).catch(err=>{
            console.error('promise catch an error:',err)
        })
    }
}
